import { FC, useEffect, useRef, useState } from 'react';
// import { Typography } from 'antd';
import { v4 } from 'uuid'; // 用来生成不重复的key
import { useMethods } from '@lhb/hook';
import { isArray } from '@lhb/func';
import { surroundClusterAndShops } from '@/common/api/expandStore/expansionCircleTask';
import { CircleBusinessZoom } from './ts-config';
// import cs from 'classnames';
import styles from './index.module.less';
import ReactDOM from 'react-dom';
import IconFont from '@/common/components/IconFont';
// const { Text } = Typography;

// 这里不写枚举是因为类似的枚举全局搜出来不少，不敢乱用，怕被误改
const showTargetShopStatus = [
  100, // 已签约
  300, // 已交房
  500, // 开业中
  700, // 已闭店
];

/**
 * @Description 周边500米已签约、已交房、开业中、已闭店的门店
 */
const RimShop: FC<{
  /** 地图实例 */
  _mapIns?: any;
  /** 是否需要主动加载数据 */
  needLoadData: any;
  /** 模型配置id */
  modelConfigId?: number;
}> = ({
  _mapIns,
  needLoadData,
  modelConfigId,
}) => {
  const shopMarkersOverlayGroup: any = useRef(); // 门店的覆盖物群组
  const curShopId: any = useRef();
  const timerRef: any = useRef();
  const curShopMarkerInfo: any = useRef([]); // 当前显示的门店信息覆盖物
  const [shopList, setShopList] = useState<any[]>([]); // 周边500米门店

  useEffect(() => {
    if (!_mapIns) return;
    methods.loadData();
  }, [_mapIns, needLoadData, modelConfigId]);

  useEffect(() => {
    if (!_mapIns) return;
    if (isArray(shopList) && shopList.length) {
      // 绘制门店markers
      methods.addShopMarkes();
      return;
    }
    // 清除marker
    shopMarkersOverlayGroup.current && shopMarkersOverlayGroup.current.clearOverlays();
    curShopMarkerInfo.current && _mapIns.remove(curShopMarkerInfo.current);
    timerRef.current && clearTimeout(timerRef.current);
    curShopId.current = null;
  }, [_mapIns, shopList]);

  const methods = useMethods({
    loadData: async () => { // 获取地图中心点500米的门店
      // 获取此时地图的中心点
      const center = _mapIns.getCenter();
      const { lng, lat } = center || {};
      if (!(+lng && +lat)) return;
      const params: any = {
        lng,
        lat,
        distance: 500, // 需求是周边500米
      };
      if (modelConfigId) {
        params.modelConfigId = modelConfigId;
      }
      const data = await surroundClusterAndShops(params);
      const { shopList } = data || {};
      // 只展示已签约、已交房、开业中、已闭店
      setShopList(isArray(shopList) ? shopList.filter((item: any) => {
        // type 类型 1:机会点 2:门店
        const { type, status } = item;
        return type === 2 && showTargetShopStatus.includes(status);
      }) : []);
    },
    addShopMarkes: () => { // 地图上显示门店markers
      const markers: any[] = [];
      shopList.forEach((shopItem: any) => {
        const { lng, lat } = shopItem || {};
        if (!(+lng && +lat)) return;
        const shopItemUUID = v4();
        const marker = new window.AMap.Marker({
          zooms: [CircleBusinessZoom.MinZomm, 20],
          anchor: 'top-left',
          position: new window.AMap.LngLat(+lng, +lat),
          offset: [-12, -13],
          content: `<div id=${shopItemUUID}></div>`,
          extData: {
            ...shopItem,
            uuid: shopItemUUID,
          }
        });
        markers.push(marker);
      });
      const overlayGroup = new window.AMap.OverlayGroup(markers); // 覆盖物群组
      _mapIns.add(overlayGroup); // 先添加到地图
      shopMarkersOverlayGroup.current && shopMarkersOverlayGroup.current.clearOverlays(); // 移除旧的
      shopMarkersOverlayGroup.current = overlayGroup; // 赋值到ref
      // 添加到地图之后开始渲染
      markers.forEach((markerItem: any) => {
        const { _opts } = markerItem;
        const { extData } = _opts || {};
        const { uuid } = extData;
        if (!uuid) return;
        const ShopItemMarker = <div style={{
          background: '#fff',
          width: '20px',
          height: '20px',
        }}
        onClick={() => methods.showMarkerItemInfo(extData)}
        >
          <IconFont
            iconHref={extData.icon}
            style={{
              color: extData.color,
              width: 24,
              height: 26,
              marginLeft: '-2px',
              marginTop: '-2px',
            }}
          />
          {/* 该方案行不通 */}
          {/* <Popover
            overlayStyle={{
              marginTop: '28px'
            }}
            content={
              <div style={{
                margin: '-6px -10px'
              }}
              >
                <div className='fs-12'>
                  <Text
                    style={{ width: 230 }}
                    ellipsis={{ tooltip: name }}>
                    {name}
                  </Text>
                  <div style={{ color }}>{statusName}</div>
                </div>
              </div>
            }
            trigger='click'
            getPopupContainer={(triggerNode: any) => triggerNode.parentNode}
          >
            <IconFont
              iconHref={extData.icon}
              style={{
                color: extData.color,
                width: 24,
                height: 26
              }}
            />
          </Popover> */}
        </div>;
        ReactDOM.render(ShopItemMarker, document.getElementById(uuid));
      });
    },
    showMarkerItemInfo: (data: any) => {
      const { lng, lat, statusName, color, id: shopId, address } = data;
      // 点击的是同一个marker时
      if (curShopId.current === shopId) return;
      // 清除上一个定时器
      timerRef.current && clearTimeout(timerRef.current);
      // 清除上一个marker
      curShopMarkerInfo.current && (_mapIns.remove(curShopMarkerInfo.current));
      curShopId.current = shopId;
      const uuid = v4();
      const marker = new window.AMap.Marker({
        zooms: [CircleBusinessZoom.MinZomm, 20],
        anchor: 'top-left',
        position: new window.AMap.LngLat(+lng, +lat),
        offset: [-12, 15],
        content: `<div id=${uuid}></div>`,
        zIndex: 200,
        extData: {
          ...data,
        }
      });
      _mapIns.add(marker);
      curShopMarkerInfo.current = marker;
      const MarkerItemCom = <div className={styles.markerItemCon}>
        {/* 和父级markerItemCon宽度保持一致 */}
        {/* <Text style={{ width: 230 }} ellipsis={{ tooltip: address }}> */}
        {address}
        {/* </Text> */}
        <div style={{
          color
        }}>{statusName}</div>
      </div>;
      ReactDOM.render(MarkerItemCom, document.getElementById(uuid));
      // 3秒后自动消失
      timerRef.current = setTimeout(() => {
        _mapIns.remove(curShopMarkerInfo.current);
        curShopId.current = null;
      }, 3000);
    },
  });
  return (
    <></>
  );
};

export default RimShop;
